<template>
  <div class="warning-message-container">
    <div class="ic-warning" />
    <span class="warning-message" v-html="message"></span>
  </div>
</template>

<script>
export default {
	name: "WarningMessage",
	props: ["message"],
};
</script>

<style lang="scss">
.warning-message-container {
	text-align: center;
	.ic-warning {
		width: 41px;
		height: 41px;
		margin: 0 auto 28px;
	}

	.warning-message {
		font-size: 15px;
		line-height: 25px;
		font-weight: normal;
		font-style: normal;
		font-stretch: normal;
		letter-spacing: -0.9px;
		color: #9b9b9b;
	}
}
</style>
